import { DashBoardWrapper } from "./styled"
import { FaUserPlus, FaDonate, FaCalendarCheck, FaMoneyCheck, FaStar } from "react-icons/fa";
import { useState } from "react";

import DoughnutChart from "components/Doughnut";
import LineChart from "components/LineChart";

const DashBoard = () => {
    document.title = 'Trang chủ'
    const [totalCustomer, setTotalCustomer] = useState(0)
    const [totalProduct, setTotalProduct] = useState(0)
    const [totalOrderWaitConfirm, setTotalOrderWaitConfirm] = useState(0)

    return (
        <DashBoardWrapper>
            <ul className="admin_dashboard_statistical">
                <li className="admin_dashboard_statistical_col">
                    <div>
                        <i className="statistical_icon_user bg-color24"><FaUserPlus /></i>
                        <div>
                            <h4 className="text-color25">Khách hàng</h4>
                            <p className="text-color18">{totalCustomer}</p>
                        </div>
                    </div>
                </li>
                <li className="admin_dashboard_statistical_col">
                    <div>
                        <i className="statistical_icon_product bg-color18"><FaCalendarCheck /></i>
                        <div>
                            <h4 className="text-color25">Tổng sản phẩm</h4>
                            <p className="text-color18">{totalProduct}</p>
                        </div>
                    </div>
                </li>
                <li className="admin_dashboard_statistical_col">
                    <div>
                        <i className="statistical_icon_order bg-color21"><FaMoneyCheck /></i>
                        <div>
                            <h4 className="text-color25">Đơn hàng chờ xử lý</h4>
                            <p className="text-color18">{totalOrderWaitConfirm}</p>
                        </div>
                    </div>
                </li>
                <li className="admin_dashboard_statistical_col">
                    <div>
                        <i className="statistical_icon_price bg-color19"><FaDonate /></i>
                        <div>
                            <h4 className="text-color25">Tổng doanh thu</h4>
                            <p className="text-color18">20000 ₫</p>
                        </div>
                    </div>
                </li>
            </ul>
            <div className="admin_dashboard_chart">
                <div className="admin_dashboard_chart_line">
                    <LineChart />
                </div>
                <div className="admin_dashboard_chart_doughnut">
                    <DoughnutChart />
                </div>
            </div>
        </DashBoardWrapper>
    )
}

export default DashBoard